import { render, staticRenderFns } from "./SConfirmDialog.vue?vue&type=template&id=2319f33f&"
import script from "./SConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./SConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports